import { useState } from 'react';
import ModuleFilters, { TgetFiltersList } from '../../../../../../../../components/ModuleFilters/ModuleFilters';
import { CONFIGURATION_STATUS } from '../../../../../../../../types/product.configuration.types';
import { CONFIG_CLASS_FILTER_NAME } from '../../../../../../../../types/product.configuration.types';
import { Button } from 'antd';
import PlusButton from '../../../../../../../../assets/images/searchBar/plusButton';
import useConfigurationGlobalState from '../../../configurationGlobalState';
import useFiltersState from '../../../../../../../../state/useFiltersState';
import SearchBar from '../../../../../../../../components/searchBar/SearchBar';
import './ConfigurationListingFilters.scss';

const ConfigurationListingFilters = () => {
  const { setIsAddConfigModalOpen } = useConfigurationGlobalState();
  const { searchText, setSearchText } = useConfigurationGlobalState();
  const { configurationFilters, setConfigurationFilters } = useFiltersState();

  const [openedTypeFilter, setOpenedTypeFilter] = useState<boolean>(false);
  const [openedToolsFilter, setOpenedToolsFilter] = useState<boolean>(false);

  const classRawOptions = CONFIG_CLASS_FILTER_NAME;
  const statusRawOptions = Object.values(CONFIGURATION_STATUS);

  const configurationListingFiltersMapping = {
    class: 'class',
    status: 'status'
  };

  const getConfigurationListingFiltersList: TgetFiltersList = (
    formModuleFilters,
    handleClickFilterOption,
    getFilterActiveStatus
  ) => [
    {
      title: 'Clase',
      openFunction: setOpenedTypeFilter,
      openStatus: openedTypeFilter,
      rawSelectOptions: formModuleFilters('class', classRawOptions),
      handleChangeSelectedOption: handleClickFilterOption('class', 'name'),
      isFilterActive: getFilterActiveStatus('class')
    },
    {
      title: 'Estado',
      openFunction: setOpenedToolsFilter,
      openStatus: openedToolsFilter,
      rawSelectOptions: formModuleFilters('status', statusRawOptions),
      handleChangeSelectedOption: handleClickFilterOption('status', 'name'),
      isFilterActive: getFilterActiveStatus('status')
    }
  ];

  const handleOpenAddConfigModal = () => {
    setIsAddConfigModalOpen(true);
  };

  return (
    <div className="configurationListingFilters">
      <div className="leftContent">
        <div className="searchContainer">
          <SearchBar
            searchText={searchText}
            setSearchText={setSearchText}
            customPlaceholder="Busca por nombre o características"
          />
        </div>
        <div className="ml-12">
          <ModuleFilters
            customGap={12}
            moduleFilters={configurationFilters}
            getFiltersList={getConfigurationListingFiltersList}
            setModuleFilters={setConfigurationFilters}
            moduleFiltersTitlesMapping={configurationListingFiltersMapping}
          />
        </div>
      </div>
      <Button
        className="creatButtonWithIcon"
        icon={
          <div className="iconStyle">
            <PlusButton className="iconPositionButton" />
          </div>
        }
        onClick={handleOpenAddConfigModal}
      >
        Agregar configuraciones
      </Button>
    </div>
  );
};

export default ConfigurationListingFilters;
